export const AdminAracEkleOptions = [
    {
        id:1,
        name:"Çekici"
      },
    {
      id:2,
      name:"Kırkayak",
      trailerTypesModel: [
            {
                "id": 1,
                "name": "Tenteli"
            },
            {
                "id": 2,
                "name": "Açık"
            },
            {
                "id": 4,
                "name": "Soğutuculu (-18 +18)"
            },
           
            {
                "id": 6,
                "name": "Yandan Kapaklı Damperli"
            },
            {
                "id": 7,
                "name": "Havuz Kasa (Hafriyat Tipi)"
            }
        ]
    },
    {
      id:3,
      name:"10 Teker Kamyon",
      trailerTypesModel: [
            {
                "id": 1,
                "name": "Tenteli"
            },
            {
                "id": 2,
                "name": "Açık"
            },
            {
                "id": 4,
                "name": "Soğutuculu (-18 +18)"
            },
           
            {
                "id": 6,
                "name": "Yandan Kapaklı Damperli"
            },
            {
                "id": 7,
                "name": "Havuz Kasa (Hafriyat Tipi)"
            }
        ]
    },
    {
      id:4,
      name:"6 Teker Kamyon",
      trailerTypesModel: [
            {
                "id": 1,
                "name": "Tenteli"
            },
            {
                "id": 2,
                "name": "Açık"
            },
            {
                "id": 4,
                "name": "Soğutuculu (-18 +18)"
            },
           
            {
                "id": 6,
                "name": "Yandan Kapaklı Damperli"
            },
            {
                "id": 7,
                "name": "Havuz Kasa (Hafriyat Tipi)"
            }
        ]
    },
    {
        id:5,
        name:"Römork",
        trailerTypesModel:[
              {
                  "id": 1,
                  "name": "Tenteli"
              },
              {
                  "id": 2,
                  "name": "Açık"
              },
              {
                  "id": 4,
                  "name": "Soğutuculu (-18 +18)"
              },
              
              {
                  "id": 8,
                  "name": "Sal Kasa (Konteyner Dorsesi)"
              },
              {
                  "id": 9,
                  "name": "Jumbo Tenteli"
              },
              {
                  "id": 10,
                  "name": "Lowbed"
              },
              {
                  "id": 11,
                  "name": "Tanker Sıvı Yük"
              }
          ]
      },
      {
        id:6,
        name:"Y.Römork",
        trailerTypesModel:[
          {
              "id": 1,
              "name": "Tenteli"
          },
          {
              "id": 2,
              "name": "Açık"
          },
          {
              "id": 4,
              "name": "Soğutuculu (-18 +18)"
          },
          {
              "id": 8,
              "name": "Sal Kasa (Konteyner Dorsesi)"
          },
          {
              "id": 9,
              "name": "Jumbo Tenteli"
          },
          {
              "id": 10,
              "name": "Lowbed"
          },
          {
              "id": 11,
              "name": "Tanker Sıvı Yük"
          },
          
        ]
      },
    {
      id:7,
      name:"Kamyonet",
      trailerTypesModel: [
            {
                "id": 2,
                "name": "Açık"
            },
            {
                "id": 3,
                "name": "Kapalı"
            },
            {
                "id": 4,
                "name": "Soğutuculu (-18 +18)"
            }
        ]
    },
    {
        "id": 8,
        "name": "Panelvan",
        "trailerTypesModel": []
    }
  ]